import styled from '@emotion/styled';
import { Typography } from 'radiance-ui';
import { SPACER, MEDIA_QUERIES } from 'radiance-ui/lib/constants';

export const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.COLORS.background};
  color: ${({ theme }) => theme.COLORS.primary};
`;

export const DesktopWrapper = styled(Wrapper)`
  ${MEDIA_QUERIES.mdUp} {
    height: calc(100vh - 75px);
  }
`;

export const Title = styled(Typography.Title)`
  margin-top: ${SPACER.xlarge};
`;

export const BodyText = styled.p`
  margin-top: ${SPACER.small};
`;
